module.exports = __webpack_public_path__ + "assets/position.0532581a.svg";